module.exports = __webpack_public_path__ + "img/icon.c0994b47.svg";